import React from "react";

import { AppBar } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

import IntlMessage from '../../LocaleEngine';

export default function TabsComponent(props) {
  const { value, children, onChange, className, variant } = props;

  return (
      <AppBar position="static" className="tabBar">
        <Tabs
          className={className}
          value={value}
          onChange={onChange}
          variant={variant || "fullWidth"}
          scrollButtons={"on"}
        >
          {children.map((child, index) => {
            return <Tab key={"tab_" + index} className={child.props.className} label={<IntlMessage id={child.props.label} />} />
          })}
        </Tabs>
      </AppBar>
  );
}